import { PlanType } from 'api-validations/user-api'
import { generatePath, Navigate, Outlet } from 'react-router'
import { isActivePlan, useOrgCodeOrUndefined, useOrgInfo } from 'shared-ui/active-operation'
import { useSyncSearchParams } from 'shared-ui/map'
import { isNil } from 'utils'

import { path } from '../../../routes/paths'

/**
 * This is a layout component because it needs to be inside the router to get
 * access to the active org code, and this way we can wrap every page in this
 * guard (for a set of routes).
 *
 * In a perfect world, this might just be a hook, but this suffices.
 */
export const RequireActiveOrgPlanGuard: React.FC = () => {
  const orgInfo = useOrgInfo()
  const orgCode = useOrgCodeOrUndefined() ?? '' // TODO: this should really not be undefined but apparently the component is used in a way that it can be

  useSyncSearchParams() // initialize map store from URL, only needs to happen once in app

  // Dealer orgs have their own plan type and are always considered active
  if (isNil(orgInfo) || isActivePlan(orgInfo) || orgInfo.planType === PlanType.Dealer) {
    return <Outlet />
  }

  return <Navigate to={generatePath(path.inactiveOperation, { orgCode })} replace />
}
